import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Col from '../../../node_modules/reactstrap/esm/Col.js';
import Theme from '../../../Theme/index.js';

var _templateObject;
var _Theme$colors = Theme.colors,
  blueGrey = _Theme$colors.blueGrey,
  pearlGrey = _Theme$colors.pearlGrey;
var CommentField = styled.textarea.attrs(function (props) {
  return {
    cols: 30,
    rows: 4,
    placeholder: "Your Comments",
    value: props.comment
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-top: .5rem;\n  padding-left: 1.5rem;\n  color: ", ";\n  border: 1px solid ", ";\n  font-size: 1rem;\n  font-weight: 400;\n\n  &::placeholder {\n    color: ", ";\n  }\n}\n"])), blueGrey, pearlGrey, blueGrey);
var CommentCol = function CommentCol(_ref) {
  var comment = _ref.comment,
    onCommentChange = _ref.onCommentChange;
  return /*#__PURE__*/React__default.createElement(Col, {
    md: "6"
  }, /*#__PURE__*/React__default.createElement("p", null, "What do you like most/least about this version of pga.org?"), /*#__PURE__*/React__default.createElement(CommentField, {
    comment: comment,
    onChange: onCommentChange
  }));
};
CommentCol.propTypes = {
  comment: PropTypes.string,
  onCommentChange: PropTypes.func.isRequired
};

export { CommentCol as default };
